import { PersonaPrimaryAttributes } from "@/inference/engine/attributes/persona/types";
import { PersonaCondition } from "./type";

export function checkValue(
  value: unknown,
  values: Array<string | number | boolean>,
): boolean {
  if (value === undefined || value === null) return false;
  if (typeof value === "string") {
    return values.some(
      (condition) => String(condition).toLowerCase() === value.toLowerCase(),
    );
  }
  if (typeof value === "number") {
    return values.includes(value);
  }
  if (typeof value === "boolean") {
    return values.includes(value);
  }
  return Object.values(value).some((v) => checkValue(v, values));
}

export function calculatePersona(
  personaConditions: PersonaCondition[],
  merchandiseData: PersonaPrimaryAttributes,
) {
  const scores = personaConditions.map(({ name, conditions }) => {
    let totalWeight = 0;
    let matchWeight = 0;
    conditions.forEach(({ attribute, values, weight: w }) => {
      let attributeValue =
        merchandiseData[attribute as keyof typeof merchandiseData];
      if (attributeValue === undefined) return;
      totalWeight += w;
      if (checkValue(attributeValue, values)) {
        matchWeight += w;
      }
    });
    const score = totalWeight > 0 ? matchWeight / totalWeight : 0;
    return {
      name,
      score,
    };
  });
  const sortedScores = scores.sort((a, b) => b.score - a.score);
  return sortedScores[0].name;
}

export function saveProductToMemory(data: { list: any[] }) {
  return data.list.map((item: { id: string }) => {
    if (!window.helium.datastore.memory.product) {
      window.helium.datastore.memory.product = {};
    }
    if (!window.helium.datastore.memory.product[item.id]) {
      window.helium.datastore.memory.product[item.id] = {};
    }
    window.helium.datastore.memory.product[item.id].details = item;
    return item.id;
  });
}

export function cleanName(name: string) {
  return name
    .replace(/[^a-zA-Z0-9_-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();
}
